// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dnd-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 465px;
  height: 124px;
  border: 1px dashed grey;
  border-radius: 4px;
}
.dnd-container.drag-over {
  border: 1px dashed lightgrey;
}
.dnd-container p {
  margin-bottom: 8px;
}
.dnd-container p.dnd-text-selected-file {
  margin: 2px 0;
}
.dnd-container p.dnd-text-selected-file span {
  font-weight: 400;
}
.dnd-container .dnd-text {
  font-size: 14px;
  font-weight: 700;
}
.dnd-container span {
  pointer-events: none;
}
.dnd-container .file-input {
  display: none;
}
.dnd-container #fileDropRef {
  visibility: hidden;
}
.dnd-container button.btn-upload {
  border: none;
  font-size: 14px;
  padding: 8px 22px;
  border-radius: 4px;
  background-color: rgb(193, 193, 193);
  color: white;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
